/* start - flights_split_bounds_us */
import { Actions, ActionTypes } from "./actions";
import { getInitialState, State } from "./state";

const initialState = getInitialState();

const reducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case ActionTypes.fetchOutbound:
      return {
        ...state,
        outbound: {
          ...state.outbound,
          fetchStatus: "loading",
          error: undefined,
          /* start - flights_alternative_fares_for_sold_out_errors_web */
          fetchedAt: undefined
          /* end - flights_alternative_fares_for_sold_out_errors_web */
        }
      };
    case ActionTypes.fetchInbound:
      return {
        ...state,
        inbound: {
          ...state.inbound,
          fetchStatus: "loading",
          error: undefined,
          /* start - flights_alternative_fares_for_sold_out_errors_web */
          fetchedAt: undefined
          /* end - flights_alternative_fares_for_sold_out_errors_web */
        }
      };

    case ActionTypes.fetchSuccessOutbound:
      return {
        ...state,
        outbound: {
          ...state.outbound,
          flights: action.payload.flightOffers,
          atolProtectedStatus: action.payload.atolProtectedStatus,
          cabinClassExtension: action.payload.cabinClassExtension,
          subsidizedFaresSummary: action.payload.subsidizedFaresSummary || [],
          availableFilters: action.payload.aggregation,
          baggagePolicies: action.payload.baggagePolicies,
          flightDeals: action.payload.flightDeals,
          fetchStatus: "success",
          error: undefined,
          campaignBanner: action.payload.campaignBanner,
          banners: action.payload.banners,
          searchCriteria: action.payload.searchCriteria,
          searchId: action.payload.searchId,
          displayOptions: action.payload.displayOptions,
          remoteBanners: action.payload.remoteBanners,
          personalisationSegments: action.payload.personalisationSegments,
          /* start -  flights_alternative_fares_for_sold_out_errors_web */
          fetchedAt: new Date().getTime()
          /* end - flights_alternative_fares_for_sold_out_errors_web */
        }
      };

    case ActionTypes.fetchSuccessInbound:
      return {
        ...state,
        inbound: {
          ...state.inbound,
          flights: action.payload.flightOffers,
          atolProtectedStatus: action.payload.atolProtectedStatus,
          cabinClassExtension: action.payload.cabinClassExtension,
          subsidizedFaresSummary: action.payload.subsidizedFaresSummary || [],
          availableFilters: action.payload.aggregation,
          baggagePolicies: action.payload.baggagePolicies,
          flightDeals: action.payload.flightDeals,
          fetchStatus: "success",
          error: undefined,
          campaignBanner: action.payload.campaignBanner,
          banners: action.payload.banners,
          searchCriteria: action.payload.searchCriteria,
          searchId: action.payload.searchId,
          displayOptions: action.payload.displayOptions,
          remoteBanners: action.payload.remoteBanners,
          personalisationSegments: action.payload.personalisationSegments,
          /* start -  flights_alternative_fares_for_sold_out_errors_web */
          fetchedAt: new Date().getTime()
          /* end - flights_alternative_fares_for_sold_out_errors_web */
        }
      };

    case ActionTypes.fetchErrorOutbound:
      return {
        ...state,
        outbound: {
          ...state.outbound,
          fetchStatus: "failed",
          error: action.payload,
          flights: [],
          availableFilters: {}
        }
      };

    case ActionTypes.fetchErrorInbound:
      return {
        ...state,
        inbound: {
          ...state.inbound,
          fetchStatus: "failed",
          error: action.payload,
          flights: [],
          availableFilters: {}
        }
      };

    case ActionTypes.resetOutbound:
      return {
        ...state,
        outbound: getInitialState().outbound
      };

    case ActionTypes.resetInbound:
      return {
        ...state,
        inbound: getInitialState().inbound
      };

    case ActionTypes.resetAllBounds:
      return getInitialState();

    default:
      return state;
  }
};

export { reducer, getInitialState };
/* end - flights_split_bounds_us */
